"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAnySegmentFolderType = exports.getFolderTypeFromObjectType = exports.getObjectTypeFromFolderType = exports.isObjectSegmentFolderType = void 0;
const sync_engine_helper_1 = require("./sync_engine_helper");
const isObjectSegmentFolderType = (type) => {
    return !!type && type.startsWith("objects-");
};
exports.isObjectSegmentFolderType = isObjectSegmentFolderType;
const getObjectTypeFromFolderType = (folderType) => {
    var _a, _b;
    return (_b = (_a = folderType === null || folderType === void 0 ? void 0 : folderType.split) === null || _a === void 0 ? void 0 : _a.call(folderType, "-")) === null || _b === void 0 ? void 0 : _b[1];
};
exports.getObjectTypeFromFolderType = getObjectTypeFromFolderType;
const getFolderTypeFromObjectType = (objectType) => {
    if (objectType === sync_engine_helper_1.endUsersObjectType)
        return "segments";
    return `objects-${objectType}`;
};
exports.getFolderTypeFromObjectType = getFolderTypeFromObjectType;
const isAnySegmentFolderType = (type) => {
    return type === "segments" || (0, exports.isObjectSegmentFolderType)(type);
};
exports.isAnySegmentFolderType = isAnySegmentFolderType;
//# sourceMappingURL=folders_helper.js.map